import api from '@/api/fyApi';
import api2 from '@/api/fy2Api'
import BaseModule from "@/common/BaseModule";
import { Module, Store } from "vuex";
import { LOAD_CHANNELS_SEARCH, SEO, LOAD_CHANNELS_ROOT } from '../protocols';
export interface State {
    albums: any[],
    page: number,
    pageSize: number,
    total: number,
    keywords: string,
    type: string,
    loading: boolean,
}

class ChannelSearch extends BaseModule<State> {
    constructor() {
        super(LOAD_CHANNELS_SEARCH[0])
    }
    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                albums: [],
                page: 0,
                pageSize: 20,
                total: 0,
                keywords: '',
                type: 'channel',
                loading: false,
            },
            mutations: {
                updateKeywords(state) {
                    state.keywords = ''
                },
                updateNotFound(state, result) {
                    state.albums = result;
                    state.page = 0;
                    state.total = 0;
                }
            },
            actions: {
                async loadNotFound({ commit }) {
                    let notfound = await api.getMovieAlbums({ offset: 0, limit: 32, recommend: 1 })
                    commit('updateNotFound', notfound.data)
                },
                async loadData({ dispatch, state }, { params }: Route) {
                    // 'channel' | 'channel_movie' | 'channel_media' | 'channel_speaker' | 'channel_short_video' | 'channel_yuedu_article'
                    if (params.kw) {
                        state.keywords = params.kw
                        state.page = parseInt(params.page) || 0
                        state.type = params.type || 'channel'
                        state.total = 0
                        state.albums = []
                        state.loading = true
                        try {
                            let result = await api2.getSearch(state.type, params.kw, state.page + 1, state.pageSize)
                            state.total = result.totalHits
                            state.albums = result.hits
                            if (result.totalHits == 0) {
                                await dispatch('loadNotFound')
                            }
                        } catch (e) {
                            await dispatch('loadNotFound')
                        } finally {
                            state.loading = false
                        }
                    } else {
                        await dispatch('loadNotFound')
                    }
                },
                [LOAD_CHANNELS_SEARCH[1]]({ dispatch, commit }, route: Route) {
                    const seoTitle = '搜索-频道-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    return Promise.all([
                        dispatch(LOAD_CHANNELS_ROOT[0] + '/loadLeft', {}, { root: true }),
                        dispatch('loadData', route),
                    ])
                }
            }
        }
    }

    clearSearch(store: Store<any>) {
        store.commit(this.key('updateKeywords'), '')
    }
}

export default new ChannelSearch();